import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { APPROUTES } from '../../../assets/constants/constants';
import withAlmToken from '../../common/withAlmToken';

const MembershipSuccess = () => {
  const navigate = useNavigate();
  useEffect(()=>{
    navigate(APPROUTES.home)
  },[])
  return <>{}</>;
};

export default withAlmToken(MembershipSuccess);
